export { default } from 'app/get-help/components/Form/Form';
